// =============================================================================
// FILE:
// frontend/src/pms/task_execution/tabs/TimelineTab.js
// =============================================================================

import React, {
  useEffect,
  useState
} from "react";


// =============================================================================
// COMPONENT
// =============================================================================

export default function TimelineTab({

  task

}) {


  // ===========================================================================
  // STATE
  // ===========================================================================
  const [events, setEvents] =
    useState([]);


  const [loading, setLoading] =
    useState(false);


  // ===========================================================================
  // LOAD
  // ===========================================================================
  useEffect(() => {

    loadTimeline();

  }, [task]);


  // ===========================================================================
  // LOAD TIMELINE
  // ===========================================================================
  const loadTimeline =
    async () => {

      try {

        setLoading(true);

        // ---------------------------------------------------------------------
        // TODO:
        // Replace with API integration
        // ---------------------------------------------------------------------

        setEvents([

          {
            id: 1,

            event_type:
              "RESERVATION",

            title:
              "Material Reserved",

            description:
              "Material reserved for task execution",

            event_date:
              "2026-05-21 10:30 AM",

            user_name:
              "Planning Engineer",

            color:
              "#2563eb"
          },

          {
            id: 2,

            event_type:
              "RECONCILIATION",

            title:
              "Material Reconciled",

            description:
              "Warehouse receipt reconciled and available for issue",

            event_date:
              "2026-05-22 03:15 PM",

            user_name:
              "Store Incharge",

            color:
              "#16a34a"
          },

          {
            id: 3,

            event_type:
              "REQUEST",

            title:
              "Material Request Submitted",

            description:
              "Task material request submitted for approval",

            event_date:
              "2026-05-23 09:45 AM",

            user_name:
              "Site Engineer",

            color:
              "#ea580c"
          },

          {
            id: 4,

            event_type:
              "APPROVAL",

            title:
              "Request Approved",

            description:
              "Material request approved by store authority",

            event_date:
              "2026-05-23 11:20 AM",

            user_name:
              "Store Manager",

            color:
              "#7c3aed"
          },

          {
            id: 5,

            event_type:
              "ISSUE",

            title:
              "Material Issued",

            description:
              "Warehouse issue completed and inventory consumed",

            event_date:
              "2026-05-23 02:10 PM",

            user_name:
              "Store Incharge",

            color:
              "#dc2626"
          }
        ]);

      } catch (err) {

        console.error(
          "Failed to load timeline",
          err
        );

      } finally {

        setLoading(false);
      }
    };


  // ===========================================================================
  // LOADING
  // ===========================================================================
  if (loading) {

    return (

      <div style={styles.loader}>

        Loading timeline...

      </div>
    );
  }


  // ===========================================================================
  // EMPTY
  // ===========================================================================
  if (!events || events.length === 0) {

    return (

      <div style={styles.emptyState}>

        No timeline events found

      </div>
    );
  }


  // ===========================================================================
  // RENDER
  // ===========================================================================
  return (

    <div style={styles.container}>


      {/* ================================================================ */}
      {/* HEADER */}
      {/* ================================================================ */}
      <div style={styles.sectionHeader}>


        <div>

          <div style={styles.title}>

            Execution Timeline

          </div>


          <div style={styles.subtitle}>


            Complete execution audit trail,
            workflow lifecycle,
            and operational traceability

          </div>

        </div>

      </div>


      {/* ================================================================ */}
      {/* TIMELINE */}
      {/* ================================================================ */}
      <div style={styles.timelineContainer}>


        {

          events.map((event, index) => (

            <div
              key={event.id}
              style={styles.timelineRow}
            >


              {/* ------------------------------------------------------ */}
              {/* LEFT TRACK */}
              {/* ------------------------------------------------------ */}
              <div style={styles.trackColumn}>


                <div
                  style={{
                    ...styles.timelineDot,

                    background:
                      event.color
                  }}
                />


                {

                  index !== events.length - 1 && (

                    <div style={styles.timelineLine} />

                  )
                }

              </div>


              {/* ------------------------------------------------------ */}
              {/* EVENT CARD */}
              {/* ------------------------------------------------------ */}
              <div style={styles.eventCard}>


                {/* -------------------------------------------------- */}
                {/* TOP */}
                {/* -------------------------------------------------- */}
                <div style={styles.eventTop}>


                  <div
                    style={{
                      ...styles.eventType,

                      background:
                        `${event.color}20`,

                      color:
                        event.color
                    }}
                  >

                    {event.event_type}

                  </div>


                  <div style={styles.eventDate}>


                    {event.event_date}

                  </div>

                </div>


                {/* -------------------------------------------------- */}
                {/* TITLE */}
                {/* -------------------------------------------------- */}
                <div style={styles.eventTitle}>


                  {event.title}

                </div>


                {/* -------------------------------------------------- */}
                {/* DESCRIPTION */}
                {/* -------------------------------------------------- */}
                <div style={styles.eventDescription}>


                  {event.description}

                </div>


                {/* -------------------------------------------------- */}
                {/* USER */}
                {/* -------------------------------------------------- */}
                <div style={styles.eventUser}>


                  By:

                  {" "}

                  <strong>

                    {event.user_name}

                  </strong>

                </div>

              </div>

            </div>
          ))
        }

      </div>

    </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  container: {

    display: "flex",

    flexDirection: "column"
  },

  sectionHeader: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 18,

    marginBottom: 18,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  title: {

    fontSize: 18,

    fontWeight: 700,

    color: "#111827"
  },

  subtitle: {

    marginTop: 6,

    fontSize: 13,

    color: "#6b7280"
  },

  timelineContainer: {

    display: "flex",

    flexDirection: "column",

    gap: 20
  },

  timelineRow: {

    display: "flex",

    alignItems: "stretch"
  },

  trackColumn: {

    width: 60,

    display: "flex",

    flexDirection: "column",

    alignItems: "center"
  },

  timelineDot: {

    width: 18,

    height: 18,

    borderRadius: "50%",

    marginTop: 8
  },

  timelineLine: {

    flex: 1,

    width: 2,

    background: "#d1d5db",

    marginTop: 4
  },

  eventCard: {

    flex: 1,

    background: "#ffffff",

    borderRadius: 14,

    padding: 20,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  eventTop: {

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    marginBottom: 12
  },

  eventType: {

    padding: "6px 12px",

    borderRadius: 999,

    fontSize: 12,

    fontWeight: 700
  },

  eventDate: {

    fontSize: 12,

    color: "#6b7280"
  },

  eventTitle: {

    fontSize: 17,

    fontWeight: 700,

    color: "#111827",

    marginBottom: 10
  },

  eventDescription: {

    fontSize: 14,

    color: "#374151",

    lineHeight: "24px",

    marginBottom: 12
  },

  eventUser: {

    fontSize: 13,

    color: "#6b7280"
  },

  loader: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 40,

    textAlign: "center"
  },

  emptyState: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 40,

    textAlign: "center",

    color: "#6b7280"
  }
};